import React, { useEffect, useState } from "react";
import DropdownList from "react-widgets/DropdownList";
import axiosInstance from "Api";
import { ErrorMessage } from "formik";
import InputWrapper from "Pages/Profile/InputWrapper";
import moment from "moment";

import {
    Col,
    FormGroup,
    Label,
    Row,
    Button,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Form, Formik } from "formik";
import { ReactComponent as PdfIcon } from "../../../assets/utils/images/svgs/PDF.svg";
import * as Yup from "yup";
import { toast } from "react-toastify";
import DatePicker, { registerLocale } from "react-datepicker";
import nl from "date-fns/locale/nl";
import { useDocTypes, useSaveDocument, useSaveUserDocument } from "Api/Common/CommonComponents";
registerLocale("nl", nl);


const GedlingForm = ({ type, saveDocTypeValue, docTypeName, doc, toggle, updateData, filterCommunity, currentUser, registerWithoutDocument }) => {
    const { trigger: saveDocument } = useSaveDocument();
    const { trigger: saveUserDocument } = useSaveUserDocument();
    const [formDataState, setFormDataState] = useState({
        docType: '',
        gelding: '',
        herinneringDatum: '',
        file: ''
    });

    const { data: docTypesResponse } = useDocTypes();
 

    useEffect(() => {
        setFormDataState({
            docType: docTypeName || "",
            gelding: "",
            herinneringDatum: "",
            file: doc || "",
        });
    }, [docTypeName, doc]);

    const docTypeList =
        docTypesResponse?.status === true
            ? docTypesResponse.data
            : [];
   
    const getPreviousDate = (val) => {
        const startDate = new Date(val);
        let date = new Date(startDate);
        date.setDate(date.getDate() - 14);
        return date;
    }

    const validationSchema = Yup.object().shape({
        docType: Yup.string().required("Veld mag niet leeg zijn"),
        gelding: Yup.string().required("Veld mag niet leeg zijn"),
    });

    const handleSubmit = (values, setSubmitting) => {
      
        setTimeout(() => {
            let formData = new FormData();
            formData.append(
                "saveWithoutDocument",
                registerWithoutDocument ? 1 : 0
            );

            if (!registerWithoutDocument && values.file) {
                formData.append("file", values.file);
            }

            formData.append("docType", values.docType);
            formData.append("gelding", values.gelding);

            if (type !== "Gebruikers") {
                formData.append("herinneringDatum", values.herinneringDatum);
            } else {
                formData.append("iAdminId", currentUser.data.clooserId);
                formData.append("iCommunityId", filterCommunity[0].iCommunityId);
            }

            const requestFn =
                type === "Gebruikers" ? saveUserDocument : saveDocument;

            requestFn({
                method: "post",
                data: formData,
                headers: {
                    "content-type": "multipart/form-data",
                },
            })
                .then((response) => {

                    if (response.status == true) {
                        toast["success"]("Instellingen zijn bijgewerkt");
                        setFormDataState({
                            docType: "",
                            gelding: "",
                            herinneringDatum: "",
                            file: "",
                        });
                        toggle();
                        updateData();
                    }

                })
                .catch((error) => console.log("catch error:", error))
                .finally(() => setSubmitting(false));
        }, 400);
    };




    return (
        <>
            <Formik
                enableReinitialize
                initialValues={formDataState}
                validationSchema={validationSchema}
                onSubmit={
                    (values, { setSubmitting }) => handleSubmit(values, setSubmitting)
                }
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form onSubmit={handleSubmit}>
                        <div>
                            <Row>
                                <Col md="12" sm="12" lg="12">
                                    {!registerWithoutDocument && (
                                        <FormGroup row >
                                            <Label className={"setting-lebel-style text-start"}>
                                                Geselecteerd bestand
                                            </Label>
                                            <Col sm={12} className="setting-lebel-style text-start">
                                                <PdfIcon /> {doc !== '' && doc.name !== undefined ? doc.name : ''}
                                            </Col>
                                            <ErrorMessage name="file" component="small"
                                                className="block mt-2 invalid-feedback" />
                                        </FormGroup>
                                    )}
                                    <div className="custom-styling  mb-3">

                                        <InputWrapper label="Document type *" labelCol={3} className={'setting-lebel-style text-start'}>
                                            <DropdownList
                                                dataKey="vName"
                                                textField="vLabel"
                                                placeholder="Selecteer"
                                                className="border rounded text-start"
                                                data={docTypeList}
                                                value={docTypeList.find(
                                                    item => item.vName === formDataState.docType
                                                ) || null}
                                                onChange={(nextValue) => {
                                                    saveDocTypeValue(nextValue.iDocTypeId, nextValue.vName);

                                                    setFormDataState(prev => ({
                                                        ...prev,
                                                        docType: nextValue.vName,
                                                    }));
                                                }}
                                            />
                                        </InputWrapper>
                                        <ErrorMessage name="docType" component="small"
                                            className="block mt-2 invalid-feedback" />
                                    </div>

                                    <FormGroup row >
                                        <Label className={"setting-lebel-style text-start"} >
                                            Geldig tot *
                                        </Label>

                                        <Col sm={12} >
                                            <div className="input-group-text input-border-styling d-flex justify-content-between">
                                                <DatePicker
                                                    locale="nl"
                                                    name="gelding"
                                                    dateFormat="dd-MM-yyyy"
                                                    className="me-2 border-0 bg-transparent float-start w-100"
                                                    selected={(values.gelding !== '' && values.gelding !== undefined) ? new Date(values.gelding) : ''}
                                                    placeholderText={'dd-mm-yyyy'}
                                                    onChange={(val) => {
                                                        setFormDataState({ ...formDataState, gelding: moment(val).format('yyyy-MM-DD'), herinneringDatum: moment(getPreviousDate(moment(val).format('yyyy-MM-DD'))).format('yyyy-MM-DD') });
                                                    }}
                                                />
                                                <FontAwesomeIcon icon={faCalendarAlt} />
                                            </div>
                                            <ErrorMessage name="gelding" component="small"
                                                className="block mt-2 invalid-feedback" />
                                        </Col>
                                    </FormGroup>

                                    {
                                        values.gelding !== '' && type !== "Gebruikers" &&
                                        <FormGroup row >
                                            <Label className={"setting-lebel-style text-start"}>
                                                Datum herinnering
                                            </Label>

                                            <Col sm={12} >
                                                <div className="input-group-text input-border-styling d-flex justify-content-between">
                                                    <DatePicker
                                                        locale="nl"
                                                        name="herinneringDatum"
                                                        dateFormat="dd-MM-yyyy"
                                                        className="me-2 border-0 bg-transparent float-start w-100"
                                                        selected={(values.herinneringDatum !== '' && values.herinneringDatum !== undefined) ? new Date(values.herinneringDatum) : ''}
                                                        placeholderText={'dd-mm-yyyy'}
                                                        onChange={(val) => {
                                                            setFormDataState({ ...formDataState, herinneringDatum: moment(val).format('yyyy-MM-DD') })
                                                        }}
                                                    />
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                </div>
                                                <ErrorMessage name="herinneringDatum" component="small"
                                                    className="block mt-2 invalid-feedback" />
                                            </Col>

                                        </FormGroup>

                                    }

                                </Col>
                            </Row>
                            <Button className="align-items-center btn-color-style mb-2 me-2 " size="sm" outline color="primary" type="submit" disabled={isSubmitting}
                            >
                                Opslaan
                            </Button>
                        </div>
                    </Form>

                )}
            </Formik>

        </>
    )
}

export default GedlingForm;
